import React from 'react';
import clsx from 'clsx';
import PageHeader from 'components/common/general/layouts/PageHeader';
import UploadExhibitsContent from 'components/upload-exhibits';
import { createStyles } from '../../globalStyles';

const UploadExhibitsPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={clsx(classes.pageWrapper, classes.simplePageWrapper)}>
      <PageHeader title="Upload exhibits" spacing="WITH_ACTION_BELOW" />
      <UploadExhibitsContent />
    </div>
  );
};

export default UploadExhibitsPage;
